module.exports = __webpack_public_path__ + "static/media/greyTick.45e210e5.svg";